module.exports = __webpack_public_path__ + "img/7.52d23a0c.jpg";